import sArrowLeftBtn from "@assets/imgs/btns/s-arrow-left-btn.png";
import sArrowRightBtn from "@assets/imgs/btns/s-arrow-right-btn.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

export const ArrowDirection = {
  LEFT: "LEFT",
  RIGHT: "RIGHT",
} as const;

export type ArrowDirection =
  (typeof ArrowDirection)[keyof typeof ArrowDirection];

export const ArrowRole = {
  PREV: "PREV",
  NEXT: "NEXT",
  DONE: "DONE",
} as const;

export type ArrowRole = (typeof ArrowRole)[keyof typeof ArrowRole];

export class SArrowBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;

  readonly role: ArrowRole;

  static preload(scene: Phaser.Scene) {
    scene.load.image("s-arrow-left-btn", sArrowLeftBtn);
    scene.load.image("s-arrow-right-btn", sArrowRightBtn);
  }

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: {
      direction?: ArrowDirection;
      role?: ArrowRole;
      onClick: () => void;
    },
  ) {
    super(scene, x, y, {
      onClick: options.onClick,
      sfx: () => AudioManager.playSfx("sfx-button"),
      onPress: () => this.setPressedStyle(),
      onRelease: () => this.resetButton(),
    });

    const { direction = ArrowDirection.LEFT, role = ArrowRole.PREV } = options;

    this.role = role;

    this.bg = scene.add
      .image(
        0,
        0,
        direction === ArrowDirection.RIGHT
          ? "s-arrow-right-btn"
          : "s-arrow-left-btn",
      )
      .setOrigin(0.5);

    this.add(this.bg);

    this.enableButton(this.bg.width, this.bg.height);

    scene.add.existing(this);
  }

  private setPressedStyle() {
    this.setScale(0.9);
  }

  private resetButton() {
    this.setScale(1);
  }

  /** 비활성화 */
  setDisabled(disabled: boolean) {
    if (disabled) {
      this.disableInteractive();
      this.setAlpha(0.4);
      return;
    }

    this.setInteractive({ useHandCursor: true });
    this.setAlpha(1);
  }
}
